import * as R from 'ramda';

import api from '../../utils/sportsApi';

const archiveCollection = (clientId, collectionId) =>
    api.url(`/clients/${clientId}/collections/${collectionId}`).delete().res();

const archiveCollections = store => async (state, clientId, collectionIds) => {
    const userClientId = state.user.selectedUserClientId;

    // Sets Cards as loading
    const loadingState = R.assocPath(
        ['clients', userClientId, 'collections', 'list', 'isArchiving'],
        true,
        state,
    );

    store.setState(loadingState);

    const promises = collectionIds.map(collectionId =>
        archiveCollection(clientId, collectionId),
    );

    await Promise.all(promises).catch(e => {
        throw new Error(e);
    });

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        collections: {
                            list: {
                                isArchiving: R.F,
                                items: R.omit(collectionIds),
                            },
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default archiveCollections;
